const getColor = (value) => {
  if (!value) {
    return 'empty';
  }

  if (value <= 50) {
    return 'success';
  } else if (value <= 80) {
    return 'warning';
  } else {
    return `error ${value === 100 ? 'full' : ''}`;
  }
};

export default getColor;
